import React, { useState } from "react";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import './MonthlyWages.css';
import jsPDF from "jspdf";
import "jspdf-autotable";
import ExcelJS from 'exceljs';
const MonthlyWages = () => {
    const [monthlyEWages, setPayment] = useState({ wageMonth: "" });
    const [data, setData] = useState(null);
    const [isFocused, setIsFocused] = useState({ wageMonth: false });
    const [loading, setLoading] = useState(false);

    const handleGenerateReport = async () => {
        if (!monthlyEWages.wageMonth) return;

        setLoading(true);
        try {
            const res = await fetch(
                `${process.env.REACT_APP_API_BASE_URL}/api/epf-receipts/wage-month/${monthlyEWages.wageMonth}`
            );
            if (!res.ok) throw new Error("Failed to fetch data");
            const json = await res.json();
            setData(json);
        } catch (err) {
            console.error(err);
            setData(null);
        } finally {
            setLoading(false);
        }
    };
    const generateExcel = async () => {
        if (!data) return;

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("EPF Payment Confirmation Receipt");

        // Title
        worksheet.mergeCells("A1:B1");
        const titleCell = worksheet.getCell("A1");
        titleCell.value = "EPF Payment Confirmation Receipt";
        titleCell.font = { size: 16, bold: true };
        titleCell.alignment = { vertical: "middle", horizontal: "center" };

        // Add table headers
        worksheet.addRow([]);
        worksheet.addRow(["Field", "Value"]);

        Object.entries(data).forEach(([key, value]) => {
            // Format numbers
            if (typeof value === "number") value = value.toLocaleString();
            // Format dates
            if (key.toLowerCase().includes("date") && value) value = format(new Date(value), "dd-MM-yyyy");
            worksheet.addRow([key.replace(/([A-Z])/g, " $1").replace(/^./, str => str.toUpperCase()), value || ""]);
        });

        // Style header row
        worksheet.getRow(2).font = { bold: true };

        // Download Excel
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: "application/octet-stream" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `EPF_Payment_Confirmation_Receipt.xlsx`;
        link.click();
    };

    const generatePDF = () => {
        if (!data) return;

        const doc = new jsPDF({
            orientation: "portrait",
            unit: "mm",
            format: "a4",
        });

        const pageWidth = doc.internal.pageSize.getWidth();

        // Title
        doc.setFontSize(16);
        doc.setFont(undefined, "bold");
        doc.text("Payment Confirmation Receipt", pageWidth / 2, 15, { align: "center" });

        // Prepare table rows, excluding `id`
        const rows = Object.entries(data)
            .filter(([key]) => key !== "id")
            .map(([key, value]) => {
                if (typeof value === "number") value = value.toLocaleString();
                if (key.toLowerCase().includes("date") && value) value = format(new Date(value), "dd-MM-yyyy");
                return [
                    key.replace(/([A-Z])/g, " $1").replace(/^./, str => str.toUpperCase()),
                    value || ""
                ];
            });

        doc.autoTable({
            startY: 25,
            body: rows,
            theme: 'grid',           // grid theme
            styles: {
                fontSize: 10,
                fontStyle: 'normal', // remove bold
                halign: 'left',
                valign: 'middle',
                lineColor: [0, 0, 0], // black borders
                lineWidth: 0.5        // border thickness
            },
            headStyles: {
                fillColor: [41, 128, 185],
                textColor: 255,
                fontStyle: 'normal',  // remove bold for header if needed
                lineColor: [0, 0, 0], // black header borders
                lineWidth: 0.5
            },
            columnStyles: {
                0: { cellWidth: 60 },
                1: { cellWidth: 120 }
            },
        });

        doc.save(`EPF_Payment_Confirmation_Receipt.pdf`);
    };




    return (
        <div className="monthlyEWages-container">
            <div className="monthlyEWages-box">
                <h2 className="monthlyEWages-heading">Payment Confirmation Receipt</h2>

                {/* Wage Month Picker */}
                <div className="monthlyEWages-maincontainer">
                    <div className="monthlyEWages-container-part">
                        <div
                            className={`monthlyEWages-floating-label-container-2 ${isFocused.wageMonth || !!monthlyEWages.wageMonth ? "float-label" : ""
                                }`}
                        >
                            <DatePicker
                                selected={
                                    monthlyEWages.wageMonth
                                        ? new Date(
                                            `${monthlyEWages.wageMonth.split("-")[1]}-${monthlyEWages.wageMonth.split("-")[0]}-01`
                                        )
                                        : null
                                }
                                onChange={(date) => {
                                    if (date) {
                                        const formatted = format(date, "MMM-yyyy").toUpperCase();
                                        setPayment((prev) => ({ ...prev, wageMonth: formatted }));
                                    } else {
                                        setPayment((prev) => ({ ...prev, wageMonth: "" }));
                                    }
                                }}
                                dateFormat="MMM-yyyy"
                                showMonthYearPicker
                                placeholderText="MMM-yyyy"
                                className="did-floating-input"
                            />
                            <label>
                                <span className="required">*</span>Wage Month
                            </label>
                        </div>
                    </div>
                </div>

                {/* Generate Report Button */}
                <div className="monthlyEWages-btn-div">
                    {/* <button className="monthlyEWages-clear"
                        //onClick={handleClear}
                        disabled={!monthlyEWages.wageMonth || loading}>
                        {loading ? "Clear..." : "Clear"}
                    </button> */}
                    <button className="monthlyEWages-btn"
                        onClick={handleGenerateReport}
                        disabled={!monthlyEWages.wageMonth || loading}>
                        {loading ? "Generating..." : "Generate Report"}
                    </button>

                    <button
                        type="button"
                        className="monthlyewages"
                        onClick={generatePDF}
                        disabled={!data} // <-- disable button if no data
                    >
                        Download PDF
                    </button>
                </div>


            </div>

            <div className="monthlyWages-tablew">

                <div className="monthlyewages-div">
                    {/* <button
                        type="button"
                        className="monthlyewages"
                        onClick={generateExcel}
                       
                    >
                        Download Excel
                    </button> */}

                </div>
                {/* Table showing fetched data */}

                <div className="monthlyEWages-table-container" >
                    {data ? (
                        <table className="monthlyEWages-table">

                            <tbody>

                                <tr>
                                    <th className="wages-cell">TRRN No</th>
                                    <td>{data.trrnNo}</td>

                                </tr>
                                <tr>
                                    <th className="wages-cell">Challan Status</th>
                                    <td>{data.challanStatus}</td>
                                </tr>

                                <tr>
                                    <th className="wages-cell">Challan Generated On</th>
                                    <td>{format(new Date(data.challanGeneratedOn), "dd-MM-yyyy")}</td>

                                </tr>
                                <tr>
                                    <th className="wages-cell">Establishment ID</th>
                                    <td>{data.establishmentId}</td>
                                </tr>
                                <tr>
                                    <th className="wages-cell">Establishment Name</th>
                                    <td>{data.establishmentName}</td>
                                </tr>
                                <tr>
                                    <th className="wages-cell">Challan Type</th>
                                    <td>{data.challanType}</td>
                                </tr>
                                <tr>
                                    <th className="wages-cell">Total Members</th>
                                    <td>{data.totalMembers}</td>

                                </tr>
                                <tr>
                                    <th className="wages-cell">Wage Month</th>
                                    <td>{data.wageMonth}</td>
                                </tr>

                                <tr>
                                    <th className="wages-cell">Total Amount (Rs)</th>
                                    <td>{data.totalAmountRs.toLocaleString()}</td>
                                </tr>

                                <tr>
                                    <th className="wages-cell"> Account-1 Amount (Rs) </th>
                                    <td>{data.account1AmountRs.toLocaleString()}</td>
                                </tr>
                                <tr>
                                    <th className="wages-cell"> Account-2 Amount (Rs)</th>
                                    <td>{data.account2AmountRs.toLocaleString()}</td>
                                </tr>
                                <tr>
                                    <th className="wages-cell">Account-10 Amount (Rs)</th>
                                    <td>{data.account10AmountRs.toLocaleString()}</td>
                                </tr>
                                <tr>
                                    <th className="wages-cell">Account-21 Amount (Rs)</th>
                                    <td>{data.account21AmountRs.toLocaleString()}</td>
                                </tr>
                                <tr>
                                    <th className="wages-cell"> Account-22 Amount (Rs) </th>
                                    <td>{data.account22AmountRs.toLocaleString()}</td>
                                </tr>
                                <tr>
                                    <th className="wages-cell">
                                        Payment Confirmation Bank </th>
                                    <td>{data.paymentConfirmationBank}</td>
                                </tr>
                                <tr>

                                    <th className="wages-cell">CRN</th>
                                    <td>{data.crn}</td>

                                </tr>
                                <tr>
                                    <th className="wages-cell">Payment Date</th>
                                    <td>{data.paymentDate}</td>
                                </tr>
                                <tr>
                                    <th className="wages-cell">Payment Confirmation Date</th>
                                    <td>{data.paymentConfirmationDate}</td>

                                </tr>
                                <tr>
                                    <th className="wages-cell"> Total PMRPY Benefit</th>
                                    <td>{data.totalPmrpyBenefit}</td>

                                </tr>
                                <tr>
                                    <th className="wages-cell">Payment Receipt</th>
                                    <td>
                                        {data.paymentReceipt && (
                                            <a href={data.paymentReceipt} target="_blank" rel="noopener noreferrer">
                                                View File
                                            </a>
                                        )}
                                    </td>
                                </tr>
                            </tbody>

                        </table>
                    ) : (
                        <div style={{ color: "red", marginTop: "20px", fontWeight: "bold", marginLeft: "30%" }}>
                            No Data Available
                        </div>
                    )}
                </div>

            </div>
        </div>
    );
};

export default MonthlyWages;
